'use client';

import { useEffect, useState } from 'react';

import TransactionActivity from '@/components/dashboard/transaction-activity';
import DashboardHero from '@/components/dashboard/dashboard-hero';
import StatCard from '@/components/ui/cards/stat-card';

export default function DashboardPage() {
  const initialDashboardData = [
    {
      id: 'cardone',
      title: 'Amount Of Listings',
      order: 157,
      last: 178,
      price: null,
    },
    {
      id: 'cardtwo',
      title: 'Potential Income A Month',
      order: null,
      last: 12,
      price: 1489.59,
    },
    {
      id: 'cardthree',
      title: 'Avg. Income Per Rental',
      order: null,
      last: 12,
      price: 789.99,
    },
  ];

  const [dashboardData, setDashboardData] = useState(initialDashboardData);
  const [loading, setLoading] = useState(true);
  const [myid, setMyId] = useState<string | null>(null);
  const burl = process.env.NEXT_PUBLIC_API;

  // ✅ Safe sessionStorage retrieval (wrapped in try/catch)
  useEffect(() => {
    try {
      if (typeof window !== 'undefined') {
        const userId = sessionStorage.getItem('userId');
        setMyId(userId);
      }
    } catch (error) {
      console.error('sessionStorage is not available:', error);
    }
  }, []);

  useEffect(() => {
    const fetchDashboardStats = async () => {
      if (!myid) return; // ✅ Only fetch when myid is available

      try {
        const response = await fetch(`${burl}/statsdash.php`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ myid }),
        });

        const data = await response.json();
        if (
          data.rental_count !== undefined &&
          data.potential_income !== undefined
        ) {
          setDashboardData((prevData) =>
            prevData.map((item) => {
              if (item.id === 'cardone') {
                return { ...item, order: data.rental_count };
              } else if (item.id === 'cardtwo') {
                return { ...item, price: data.potential_income };
              } else if (item.id === 'cardthree') {
                return { ...item, price: data.avg_income_per_rental };
              }
              return item;
            }),
          );
        } else {
          console.error('Invalid API response:', data);
        }
      } catch (error) {
        console.error('Error fetching dashboard stats:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardStats();
  }, [myid]); // ✅ Only run when myid is set

  return (
    <div className="container-fluid mb-12 lg:mb-16">
      <DashboardHero />

      {/* Cards Grid */}
      <div className="mb-12 mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3 lg:mb-16 lg:mt-12 2xl:mt-16 2xl:gap-6">
        {dashboardData.map((item, index) => (
          <StatCard
            key={`pricing-card-${index}`}
            data={{
              ...item,
              order:
                item.id === 'cardone' && loading ? 'Loading...' : item.order,
              price:
                (item.id === 'cardtwo' || item.id === 'cardthree') && loading
                  ? 'Loading...'
                  : item.price,
            }}
          />
        ))}
      </div>

      <TransactionActivity />
    </div>
  );
}
